//
// out of a list of images it picks the smallest image that has
// more pixels than required to fill both the height and width
// dimensions without considering the aspect ratio scaling of
// the image (if the image has an aspect ratio like 200x100,
// it will really fill a 200x100 box even if we have a 300x100
// space to put the image...  the coordinates supplied here
// are post-scaling
//

export const selectImage = (images, figureWidth, figureHeight) => {
    let verticalBig = 0;
    for (let i = 0; i < images.length; i++) {
        if (images[i].height < figureHeight)
            break;
        verticalBig = i;
    }
    let horizontalBig = 0;
    for (let i = 0; i < images.length; i++) {
        if (images[i].width < figureWidth)
            break;
        horizontalBig = i;
    }
    return images[Math.min(horizontalBig, verticalBig)]
}

export const fitImageToFigure = (imageDimension, figureDimension) => {
    const [imgX, imgY] = imageDimension
    const [figureX, figureY] = figureDimension
    const ratioX = imgX / figureX
    const ratioY = imgY / figureY
    if(ratioX>ratioY) {
        return [figureX, imgY / ratioX]
    } else {
        return [imgX / ratioY, figureY]
    }
}

export const isTallImage = (image, figureWidth, figureHeight) => {
    const ratio = image.height * figureWidth / (image.width * figureHeight)
    return ratio > 1
}
